const A = /GMT(?:[-+](?:0?\d|1[0-4])(?::?[0-5]\d)?)?$/, { BASE_FORMAT_OPTIONS: I, BASE_LOCALE: N, SYSTEM_TIMEZONE: c, SYSTEM_TIMEZONE_FORMATTER: s } = (() => {
  const S = "en-US", T = "2-digit", t = "numeric", e = Object.freeze({
    year: t,
    month: "short",
    day: t,
    hour: T,
    minute: T,
    second: T,
    fractionalSecondDigits: 3,
    timeZoneName: "longOffset"
    // should not be changed — needed for the tz offsets regexp
  });
  let E, O;
  try {
    O = new Intl.DateTimeFormat(S, e), E = O.resolvedOptions().timeZone;
  } catch {
    E = void 0;
  }
  return { BASE_FORMAT_OPTIONS: e, BASE_LOCALE: S, SYSTEM_TIMEZONE: E, SYSTEM_TIMEZONE_FORMATTER: O };
})();
export {
  I as BASE_FORMAT_OPTIONS,
  N as BASE_LOCALE,
  A as REGEX_TZ_OFFSET,
  c as SYSTEM_TIMEZONE,
  s as SYSTEM_TIMEZONE_FORMATTER
};
